import { handlePostRequest } from "./PostTemplate";

// Mirrors ADDITIONAL_CHARGE_CATEGORY_FIELDS in zazio-back's controllers/invoice.js -
// a charge tagged with one of these rolls into that same flat invoice field
// server-side, so existing reports pick it up automatically. "Other" charges
// still count toward the total but don't populate a specific field.
export const CHARGE_CATEGORY_OPTIONS = [
    { label: "Other / Uncategorized", value: "" },
    { label: "Custom Duties", value: "customDuties" },
    { label: "Delivery Fee", value: "deliveryFee" },
    { label: "Oversize Fee", value: "oversizeFee" },
    { label: "Dangerous Item Fee", value: "dangerousItemFee" },
    { label: "Pickup Fee", value: "pickupFee" },
    { label: "Packaging Fee", value: "packagingFee" },
    { label: "Declaration Fee", value: "declarationFee" },
    { label: "Handling", value: "handling" },
    { label: "Insurance", value: "insurance" },
    { label: "Website Fee", value: "WebsiteFee" },
    { label: "Monthly Fee", value: "MonthlyFee" },
    { label: "Items Price", value: "itemsPrice" },
];

export const createAdditionalInvoice = (dispatch, payload) => dispatch(handlePostRequest(payload, "/additionalInvoice", true, true));

// The flat charge-category fields that bulk-payment aggregation (Outstanding,
// BillingReports x2) currently sums across selected invoices. Kept separate
// from CHARGE_CATEGORY_OPTIONS above (which also lists handling/insurance)
// because those two aren't summed by any of the existing aggregation call
// sites today - not this fix's job to change that.
const AGGREGATE_CHARGE_FIELDS = ["customDuties", "deliveryFee", "oversizeFee", "dangerousItemFee", "pickupFee", "packagingFee", "declarationFee", "MonthlyFee", "WebsiteFee", "itemsPrice"];

// Folds one invoice's charge-category fields and package line items into a
// running bulk-payment aggregate. A batch can mix standard and additional
// invoices - an additional invoice's charges are already itemized in its own
// additionalCharges list, so summing its flat fields too would double-count
// every charge (once generically, once by name), and its synthetic "package"
// row never represents real shipped weight. So: standard invoices fold into
// the flat fields + packages as before; additional invoices instead
// contribute their charges to a separate additionalCharges list. Callers
// still sum invoiceAmount/paidAmount/TotalAmount/weight themselves (those
// aren't skipped for additional invoices - weight is already 0 for them).
export const foldInvoiceCharges = (acc, item) => {
    if (item.invoiceCategory === "additional") {
        acc.additionalCharges = (acc.additionalCharges || []).concat(item.additionalCharges || []);
    } else if (item.invoiceCategory === "purchase") {
        // Goods bought for the client: its synthetic "Item Purchase" package
        // row and itemsPrice are not shipping, so they stay out of the flat
        // fields and packages - the items ride along in their own list.
        acc.purchaseItems = (acc.purchaseItems || []).concat(item.purchase?.items || []);
        acc.purchaseShipping = (acc.purchaseShipping || 0) + (Number(item.purchase?.shipping) || 0);
        acc.purchaseTax = (acc.purchaseTax || 0) + (Number(item.purchase?.tax) || 0);
    } else {
        AGGREGATE_CHARGE_FIELDS.forEach((field) => {
            acc[field] = (acc[field] || 0) + (item[field] ?? 0);
        });
        acc.packages = (acc.packages || []).concat(item.packages || []);
    }
    return acc;
};
